// extracted by mini-css-extract-plugin
export default {"container":"Menu_container__9tDYw","menuButton":"Menu_menuButton__VX2pA","menu":"Menu_menu__d7dQ8","contactLink":"Menu_contactLink__+U1l5","open":"Menu_open__OYvuQ"};